// sku-updater.js
(function () {
  function initSection(section) {
    // 1) Find the SKU element in THIS product section
    const skuEl = section.querySelector('.product-sku');
    if (!skuEl) return;

    // 2) Find product JSON (Dawn/OS2.0 themes render one of these)
    const productJsonEl =
      section.querySelector('script[type="application/json"][data-product]') ||
      section.querySelector('script[type="application/json"][id^="ProductJSON-"]') ||
      section.querySelector('script[type="application/json"][id^="ProductJson-"]');
    if (!productJsonEl) return;

    let product;
    try { product = JSON.parse(productJsonEl.textContent.trim()); } catch { return; }
    if (!product?.variants) return;

    // 3) Map variant id -> SKU
    const idToSku = new Map(product.variants.map(v => [String(v.id), v.sku || '']));

    // Helper to find the current variant id input (themes sometimes move it)
    const getIdInput = () =>
      section.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      section.querySelector('input[name="id"]');

    // 4) Paint SKU for whatever variant is currently selected
    const paint = () => {
      const idInput = getIdInput();
      if (!idInput) return;
      const vid = String(idInput.value || '');
      const sku = idToSku.get(vid) || '';
      skuEl.textContent = sku ? `SKU: ${sku}` : '';
    };

    // Initial paint
    paint();

    // 5) Repaint when the id input changes
    const idInput = getIdInput();
    if (idInput) {
      idInput.addEventListener('input', paint);
      idInput.addEventListener('change', paint);
      new MutationObserver(paint).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    // 6) Repaint when the variant picker changes (your <variant-selects> element)
    section.addEventListener('change', (evt) => {
      if (evt.target.closest('variant-selects')) paint();
    }, true);

    // 7) Also catch common custom events from themes
    ['variant:change', 'variantchange', 'theme:variant:change', 'product:variant-change']
      .forEach(ev => section.addEventListener(ev, paint, true));
  }

  function boot() {
    // Init for each product section that has a <variant-selects>
    document.querySelectorAll('variant-selects').forEach(vs => {
      const section = vs.closest('[data-section-id]') || vs.closest('section') || document;
      initSection(section);
    });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // If Shopify re-renders a product section (drawers/quick view), re-init for that section
  document.addEventListener('shopify:section:load', (e) => initSection(e.target));
})();
